import * as React from 'react';
import { appState } from 'stores/app';
import userManager from 'framework/utils/userManager';
import { Icon, Text } from 'ui';
import classNames from 'classnames';
import { prefixClassName } from '../_conf';
import { Menu } from './Menu/Menu';
import { MenuTranslations } from './translations';
import './_styles.scss';
import { DOCS_URL, isValidExternalKey } from '../../../../config';
import { i18n } from 'i18n';

export const signOutUser = async () => {
  await userManager.signoutRedirect({ id_token_hint: appState.user?.id_token });
  const { FS } = window;
  if (FS) {
    FS.identify(false);
  }
};

const clx = prefixClassName('user-block');
const clxLink = prefixClassName('link');

const docsUrl = window.docsUrl?.trim();
const isValidDocsUrl = isValidExternalKey({ docsUrl });

export const UserBlock = () => (
  <div className="wrapper">
    <a
      className={classNames(`${clx}__help-link`, clxLink)}
      href={isValidDocsUrl ? docsUrl : DOCS_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={i18n.t('generic.help')}
    >
      <Icon name="question" className={`${clx}__help-icons`} />
      <Text caption="generic.help" className={`${clx}__help-link__text`} tag="span" />
    </a>
    <Menu
      options={[
        {
          label: MenuTranslations.MyAccount,
          linkTo: '/myaccount',
        },
        {
          label: MenuTranslations.SignOut,
          onClick: signOutUser,
        },
      ]}
      keepDropdown
      buttonText={`${appState.user?.profile?.given_name} ${appState.user?.profile?.family_name}`}
      icon="account"
    />
  </div>
);
